export class Topic {
    constructor({
                    //attributes
                    id= null,
                    campaign_id = null,
                    name= '',
                    message= '',
                    extradata= {},
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.campaign_id=campaign_id;
        this.name=name;
        this.message=message;
        this.extradata=extradata;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;


    }

}

export function createTopic(data={}) {
    return Object.freeze(new Topic(data));
}